<template>
  <base-card
    dense
    class="recomendation-card"
    :class="{'recomendation-card--active': active}"
    @click.native="$emit('click')"
  >
    <div>
      <div class="d-flex align-content-between">
        <!-- Title -->
        <div>
          <PillKind :kind="career.kind_name" />
          <h4 class="recomendation-card__title">
            {{ career.name | capitalize }}
          </h4>
          <div
            class="recomendation-card__area"
          >
            {{ career.area_name | lowercase | capitalize }}
          </div>
        </div>
        <!-- /Title -->
        <div class="recomendation-card__pensum-container ml-auto">
          <div class="recomendation-card__pensum-chart-container">
            <PensumChart
              :chart-data="chartData(career.pensum)"
              :options="pieChartOptions"
            />
          </div>
          <div
            v-if="!pensumError"
            class="recomendation-card__icon-label recomendation-card__icon-label--pensum"
          >
            Pensum
          </div>
        </div>
      </div>

      <!-- <div class="recomendation-card__icons-container mt-2">
        <div class="recomendation-card__icon-container">
          <fa-icon
            class="recomendation-card__icon"
            icon="money-bill"
          />
          <div class="recomendation-card__icon-label">
            Salarios
          </div>
        </div>
        <div class="recomendation-card__icon-container">
          <fa-icon
            class="recomendation-card__icon"
            icon="briefcase"
          />
          <div class="recomendation-card__icon-label">
            Empleabilidad
          </div>
        </div>
        <div class="recomendation-card__icon-container">
          <fa-icon
            class="recomendation-card__icon"
            icon="users"
          />
          <div class="recomendation-card__icon-label">
            Pruebas Nacionales
          </div>
        </div>
        <div class="recomendation-card__pensum-container">
          <div class="recomendation-card__pensum-chart-container">
            <PensumChart
              :chart-data="chartData(career.pensum)"
              :options="pieChartOptions"
            />
          </div>
          <div class="recomendation-card__icon-label recomendation-card__icon-label--pensum">
            Pensum
          </div>
        </div>
            </div>-->
    </div>
  </base-card>
</template>

<script>
import CONFIG from '../../config';
import PensumChart from '../../components/Charts/PensumChart.vue';

export default {
    name: 'RecommendationCard',
    components: {
        PensumChart,
    },
    props: {
        active: {
            type: Boolean,
            default: false,
        },
        career: {
            type: Object,
            default() {
                return {};
            },
        },
    },
    data() {
        return {
            pieChartOptions: {
                responsive: true,
                legend: {
                    display: false,
                },
                tooltips: {
                    bodyFontSize: 12,
                },
            },
        };
    },
    computed: {
        pensumError() {
            return Object.values(this.career.pensum).indexOf('NaN') !== -1;
        },
    },
    methods: {

        chartData(pensum) {
            return {
                datasets: [
                    {
                        backgroundColor: [
                            CONFIG.COLORS.pensum.cuantitative,
                            CONFIG.COLORS.pensum.cualitative,
                            CONFIG.COLORS.pensum.optative,
                            CONFIG.COLORS.pensum.profesional,
                        ],
                        data: Object.values(pensum).map(v => Number(v).toFixed(2)),
                    },
                ],
                labels: Object.keys(pensum),
            };
        },
    },
};
</script>

<style lang="scss">
.recomendation-card {
    border: solid 1px transparent;
    transition: all 0.3s;
    cursor: pointer;
    display: flex;

    &--active {
        // background-color: rgba(#4a90e2, 0.1) !important;
        border-left: solid 5px #4a90e2 !important;
    }

    &:hover {
        border: solid 1px #4a90e2;
    }
    &__title {
        font-size: 1.275rem;
        margin-bottom: 0.3rem;
        margin-top: 0.3rem;
        line-height: 1;
    }
    &__area {
        font-size: 0.7525rem;
        color: #4a4a4a;
        text-transform: uppercase;
    }
    &__icon {
        @media (max-width: 400px) {
            margin-right: 0.5rem;
            font-size: 1rem;
            min-width: 20px;
        }

        color: #cccccc;
        font-size: 1.875rem;

        @media (min-width: 992px) and (max-width: 1199px) {
            margin-right: 0.5rem;
            font-size: 1rem;
            min-width: 20px;
        }
    }
    &__icon-label {
        font-weight: 300;
        font-size: 0.7125rem;

        &--pensum {
            @media (max-width: 400px) {
                margin-left: auto;
                margin-right: 0;
                text-align: center;
            }

            font-weight: 500;
            text-transform: uppercase;
            // width: 85px;
            text-align: center;

            @media (min-width: 992px) and (max-width: 1199px) {
                margin-left: auto;
                margin-right: 0;
                text-align: center;
            }
        }
    }
    &__icons-container {
        display: flex;
        justify-content: space-between;
        width: 100%;

        @media (max-width: 400px) {
            flex-direction: column;
            flex-wrap: wrap;
            max-height: 100px;
            justify-content: inherit;
            width: inherit;
        }

        @media (min-width: 992px) and (max-width: 1199px) {
            flex-direction: column;
            flex-wrap: wrap;
            max-height: 100px;
            justify-content: inherit;
            width: inherit;
        }
    }
    &__icon-container {
        padding-right: 0.75rem;
        display: flex;
        flex-direction: column;
        justify-content: flex-end;
        align-items: center;

        @media (max-width: 400px) {
            max-width: 50%;
            margin-bottom: 0.3rem;

            padding-right: inherit;
            flex-direction: initial;
            justify-content: inherit;

            &:first-of-type {
                margin-top: 1rem;
            }
        }

        @media (min-width: 992px) and (max-width: 1199px) {
            max-width: 50%;
            margin-bottom: 0.3rem;

            padding-right: inherit;
            flex-direction: initial;
            justify-content: inherit;

            &:first-of-type {
                margin-top: 1rem;
            }
        }
    }

    &__pensum-container {
        display: flex;
        flex-direction: column;
        justify-content: flex-end;
        align-items: center;
        padding-left: 1rem;

        @media (min-width: 992px) and (max-width: 1199px) {
            max-width: 50%;
            text-align: center;
        }
    }

    &__pensum-chart-container {
        max-width: 55px;
        margin-right: 0;
    }
}
</style>
